// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"ae4a4c3e","143":"38f9d111","571":"443903c7","742":"8de5876c"}[chunkId] + ".chunk.js";
};